import { FC } from 'react'
import styled from 'styled-components'
import CheckBoxFilterRedesign from '@/components/molecules/checkBoxFilterRedesign'
import { Box } from '@/components/atoms/Grid'
import { ExtraTinyBold, MediumTinyBold } from '@/components/atoms/typography'

type CheckboxFilterRowRedesignProps = {
  title: string
  count: number
  isChecked: boolean
  onCheckboxClick: () => void
  color?: string
  size?: number
}

const CheckboxFilterRowRedesign: FC<CheckboxFilterRowRedesignProps> = ({
  title,
  count,
  isChecked,
  onCheckboxClick,
  color,
  size = 20
}) => {
  return (
    <StyledCheckBoxFilterRedesign
      size={size}
      isChecked={isChecked}
      color={color}
      onCheckboxClick={onCheckboxClick}
    >
      <StyledMediumTinyBold>{title}</StyledMediumTinyBold>
      <StyledBox>
        <StyledExtraTinyBold>{count}</StyledExtraTinyBold>
      </StyledBox>
    </StyledCheckBoxFilterRedesign>
  )
}

export default CheckboxFilterRowRedesign

const StyledCheckBoxFilterRedesign = styled(CheckBoxFilterRedesign)`
  height: 55px;
  gap: 16px;
  padding: 8px 20px 8px 12px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100vw;
    border-bottom: 0.5px solid ${(props) => props.theme.colors.navMenuGrey};
    pointer-events: none;
  }

  &:hover {
    background-color: transparent;
  }
`

const StyledMediumTinyBold = styled(MediumTinyBold)`
  font-weight: 500;
  margin: 0 auto 0 0;
  font-size: 14px;
`

const StyledExtraTinyBold = styled(ExtraTinyBold)`
  font-weight: 400;
  margin: 0;
  font-size: 12px;
`

const StyledBox = styled(Box)`
  padding: 4px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.navMenuGrey};
`
